import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BellRing, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { API_URL } from './pendShared';

const defaultMsg = (it) => `Cliente ${it.nome || ''}: ${it.msg}. Dá seguimento a esta situação.`;

export const AlertComercialDialog = ({ open, onClose, items, onSent }) => {
  const single = items.length === 1;
  const [msg, setMsg] = useState('');
  const [sending, setSending] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (open) setMsg(single ? defaultMsg(items[0]) : ''); }, [open]);

  const send = async () => {
    setSending(true);
    try {
      const body = { items: items.map((i) => ({ tipo: i.tipo, contract_id: i.contract_id, lead_id: i.lead_id })), message: msg.trim() || null };
      const { data } = await axios.post(`${API_URL}/pendencias`, body);
      if (data.created) toast.success(`${data.created} alerta(s) enviado(s). O comercial tem 24h para dar seguimento.`);
      data.skipped?.forEach((s) => toast.warning(`${s.nome || 'Situação'}: ${s.motivo}`));
      window.dispatchEvent(new Event('pendencias-changed'));
      onSent?.();
      onClose();
    } catch (e) {
      toast.error((typeof e.response?.data?.detail === 'string' && e.response.data.detail) || 'Erro ao enviar alerta');
    } finally { setSending(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="alert-comercial-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><BellRing className="w-5 h-5 text-rose-600" />Alertar comercial</DialogTitle>
          <DialogDescription>
            {single ? `Para: ${items[0]?.comercial || 'comercial responsável'}` : `${items.length} situações — cada uma vai para o seu comercial.`}
            {' '}O comercial tem de dar como lido e tem <b>24h</b> para dar seguimento ou concluir.
          </DialogDescription>
        </DialogHeader>
        <Textarea
          rows={4} value={msg} onChange={(e) => setMsg(e.target.value)}
          placeholder={single ? '' : 'Deixe vazio para enviar a mensagem automática de cada situação'}
          data-testid="alert-comercial-message"
        />
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} data-testid="alert-comercial-cancel">Cancelar</Button>
          <Button onClick={send} disabled={sending} className="bg-rose-600 hover:bg-rose-700" data-testid="alert-comercial-send">
            {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <BellRing className="w-4 h-4" />} Enviar alerta
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
